import * as React from "react";
// import qs from 'qs'
import { Row, Col, Input, Button, AutoComplete } from "antd";
import inputEnhance from "widget/rewriteAntdHOC/input";
import autoCompleteEnhance from "widget/rewriteAntdHOC/autoComplete";

//  数据模型
import Model from "../../viewModel";
//地理行政信息(国家，城市，区域)
import * as RegionInstance from "../Region/instance";

// 地区级联
import RegionCascader from "../Region/regionCascader";

// 交易状态级联
import TradingCascader from "../tradingStatus/tradingCascader";

// 订单来源级联
import OrderSourceCascader from "../orderSource/orderSourceCascader";

// 多选标签
import MultipleTags_Simple from "../multipleTags_simple";

// 订单来源
import * as OSInstance from "../orderSource/instance";
// 贸易状态
import * as TSInstance from "../tradingStatus/instance";
// 日期范围选择
// const RangePicker = DatePicker.RangePicker;
import DateRangePicker from "../dateRangePicker";
// 轻量级的JavaScript日期库，用于解析，验证，操作和格式化日期。
// import moment from "moment";
// moment.locale("zh-cn");
// import "moment/src/locale/zh-cn";
// 选择器
import Selector from "../selector";

// 控制字段现隐抽屉组件
// import FieldDrawer from "../widget/fieldDrawer";
// // 小工具栏
// import SmallTools from "../smallTools";

// 表单提交按钮组
import SubmitButton from "../submitButton";

// 订单状态多选tag
import OrderStatus from "../orderStatus";

// 订单标签多选tag
import OrderTag from "../orderTag";

// 重写input
import RewriteInput from "widget/rewriteInput";

// 获取redux 全局数据
import { getState } from "@rematch/core";


// 获取地址栏参数
import { getSearchVal } from "utils/tool";

// import MultiSelect from "widget/multiSelect2";

import {
  // PositionProperty,
  // BorderTopProperty,
  TextAlignProperty,
  FloatProperty
} from "csstype";

const InputEnhance = inputEnhance(Input);
const AutoCompleteEnhance = autoCompleteEnhance(AutoComplete);

const search = window.location.search;
const saler = getSearchVal(search, "saler");

// form中包含的组件类型
enum EFormType {
  input = 0,
  input2 = 100,
  button = 1,
  dateRange = 2,
  select = 3,
  country = 4,
  city = 5,
  area = 6,
  // 国家，城市联动
  countryCity = 7,
  // 订单来源 二级联动
  secondaryLinkage = 8,
  // 贸易状态
  tsSecondarLinkage = 9,
  // 日期f范围控件
  rangePicker = 10,
  // 以文本显示
  text = 11,
  // 以文字链接显示
  linkText = 12,
  // 地区级联
  reginoCascader = 13,
  // 交易状态级联
  tradingCascader = 14,
  // 订单来源级联
  orderSourceCascader = 15,
  // 多选标签
  multipleTags_simple = 16,
  // 提交按钮
  submitButton = 17,
  // 订单状态多选标签
  orderStatus = 18,
  // 订单标签多选标签
  orderTag = 19,
  // 自动补全文本框
  autocomplete = 20
}

const getFormItem = (i, formItem, renderFormItem, elements) => {
  // const formItemLayout = {
  //   labelCol: { span: formItem.labelCol || 8 },
  //   wrapperCol: { span: formItem.wrapperCol || 14 }
  // };
  {
    /* <FormItem key={i} label={formItem.label} {...formItemLayout}>
        {elements}
      </FormItem> */
  }

  const formItemLayout = {
    maxWidth: 100,
    fontSize: 12,
    color: "#000",
    textAlign: "right" as TextAlignProperty,
    /* display: inline; */
    float: "left" as FloatProperty
  };

  const colStyle = {
    display: "flex",
    alignItems: "center"
  };
  if (formItem.type !== 1) {
    renderFormItem.push(
      <Col
        span={formItem.colSpan || 6}
        offset={formItem.offset || 0}
        key={i + "_" + formItem.field}
      >
        <div style={colStyle}>
          <span style={formItemLayout}>{formItem.label}</span>
          {elements}
        </div>
      </Col>
    );
  } else {
    renderFormItem.push(
      <Col
        span={formItem.colSpan || 6}
        offset={formItem.offset || 0}
        key={i + "_" + formItem.field}
      >
        {elements}
      </Col>
    );
  }
};

const renderItem = (e, i) => {
  const rowStyle = {
    marginBottom: 14
  };
  return (
    <Row gutter={24} key={i} style={rowStyle}>
      {e}
    </Row>
  );
};


export const searchFormLayout = (
  targetKeys,
  FormData,
  getValue,
  ModelName,
  onChange,
  reset,
  callback,
  containerBody,
  // 自动补全事件
  onAutoCompleteChange,
  updateHotKey
) => {
  let renderForm: any = [];
  let renderFormItem: any = [];
  let elements: any;
  let itemState: any;
  let i = 0;
  let colCount = 0;
  // 是否显示字段
  let isHiddenField = false;
  let fmList: any = [];

  for (let formItem of FormData) {
    // 判断该字段是否需要显示出来
    if (formItem.key && targetKeys) {
      isHiddenField = false;
      for (const item of targetKeys) {
        if (item[0] === formItem.key) {
          isHiddenField = true;
          break;
        }
      }
      if (isHiddenField) {
        continue;
      }
    }

    // 计算col
    if (targetKeys && targetKeys.length > 0) {
      if (formItem.type === -1) continue;
    }
    // if ((i + 1) % 4 == 0) {
    // if (!formItem.colSpan) {
    //   formItem.colSpan = 4;
    // }
    colCount += formItem.colSpan;
    //如果有默认值则赋值给Store;
    // if (formItem.value) {
    //   callback(formItem.field, formItem.value);
    // }
    // 获取redux中的对象
    itemState = getValue(formItem.field);
    const fm = new Model.FormModel();
    fm.value = itemState;
    fm.placeholder = formItem.placeholder;
    fm.field = formItem.field;
    fm.width = formItem.width;
    fm.extField1 = formItem.extField1;
    fm.extField2 = formItem.extField2;
    fm.extFieldValue1 = formItem.extFieldValue1;
    fm.extFieldValue2 = formItem.extFieldValue2;
    fm.extFieldValue3 = formItem.extFieldValue3;
    fm.extFieldValue4 = formItem.extFieldValue4;
    fm.modelName = ModelName;

    let userDefaultValue;
    if (fm.extField1 == 'user') {
      if (saler) {
        userDefaultValue = saler
      }
    }

    switch (formItem.type) {
      case EFormType.autocomplete:
        const rootState = getState();
        let dataSource: any = [];
        try {
          dataSource =
            rootState["autoComplete"][ModelName][formItem.field] || [];
          // 避免数据源中有空值
          dataSource = dataSource.filter(item => {
            return item;
          });
        } catch (error) { }

        const autoCompleteChange = e => {
          onAutoCompleteChange(formItem.field, e);
        };

        const _autoCompleteFilter = (inputValue, option) =>
          option.props.children
            .toUpperCase()
            .indexOf(inputValue.toUpperCase()) !== -1;

        elements = (
          <AutoCompleteEnhance
            dataSource={dataSource}
            style={{ width: formItem.width || 140 }}
            placeholder={fm.placeholder || "键入信息"}
            allowClear={true}
            value={itemState}
            filterOption={_autoCompleteFilter}
            onChange={autoCompleteChange}
          />
        );
        break;
      case EFormType.input:
        elements = (
          <InputEnhance
            style={{ width: formItem.width || 140 }}
            placeholder={fm.placeholder || "键入信息"}
            value={itemState}
            onPressEnter={() => {
              updateHotKey({
                hotkey: "enter",
                activity: true
              });
            }}
            onKeyDown={e => {
              if (e.keyCode == 46) {
                updateHotKey({
                  hotkey: "delete",
                  activity: true
                });
              }
            }}
            onChange={formItem.onChange || onChange}
            //这里的对应redux中的属性(字段)
            data-field={formItem.field}
          />
        );
        break;
      case EFormType.input2:
        elements = <RewriteInput />;
        break;
      case EFormType.button:
        elements = (
          <Button type="primary" onClick={formItem.onClick || null}>
            {formItem.value}
          </Button>
        );
        break;
      case EFormType.select:
        elements = (
          <Selector
            {...fm}
            selectorName={fm.extField1}
            data={fm.extFieldValue1}
            containerBody={containerBody}
            defaultValue={userDefaultValue}
          />
        );
        break;
      case EFormType.country:
        elements = RegionInstance.getCountry(fm);
        break;
      case EFormType.city:
        elements = RegionInstance.getCity(fm);
        break;
      case EFormType.area:
        elements = RegionInstance.getArea(fm);
        break;
      case EFormType.countryCity:
        elements = RegionInstance.getCountryCity(fm);
        break;
      case EFormType.secondaryLinkage:
        elements = OSInstance.getOrderSource(fm);
        break;
      case EFormType.tsSecondarLinkage:
        elements = TSInstance.getTSSecondaryLinkage(fm);
        break;
      case EFormType.rangePicker:
        elements = (
          <DateRangePicker
            {...fm}
            isShowAfterToday={fm.extFieldValue2 || false}
            disabledDate={fm.extFieldValue2}
            containerBody={containerBody}
          />
        );
        break;
      case EFormType.text:
        elements = <span> {formItem.value}</span>;
        break;
      case EFormType.linkText:
        // 使用了外部链接图标
        elements = (
          <a href={fm.extFieldValue1} target="_blink">
            <i
              className="action-user action-tiaozhuan"
              style={{ display: "inline-block" }}
            />
            {formItem.value}
          </a>
        );
        break;
      case EFormType.reginoCascader:
        const result = fm.extField2 ? Boolean(fm.extField2) : false;
        elements = (
          <RegionCascader
            {...fm}
            modelName={fm.modelName}
            //这里的对应redux中的属性(字段)
            data-field={fm.field}
            // 这里对应城市字段
            city-field={fm.extField1}
            changeOnSelect={result}
            containerBody={containerBody}
          />
        );
        break;
      // 交易状态
      case EFormType.tradingCascader:
        elements = (
          <TradingCascader
            {...fm}
            modelName={fm.modelName}
            //这里的对应redux中的属性(字段)
            data-field={fm.field}
            // 对应的是交易来源
            first-field={fm.extField1}
            // 这里对应的是状态
            second-field={fm.extField2}
            containerBody={containerBody}
          />
        );
        break;
      // 订单来源
      case EFormType.orderSourceCascader:
        elements = (
          <OrderSourceCascader
            {...fm}
            modelName={fm.modelName}
            //这里的对应redux中的属性(字段)
            data-field={fm.field}
            first-field={fm.extField2}
            // 这里对应临时字段
            second-field={fm.extField1}
            containerBody={containerBody}
          />
        );
        break;
      // 多选标签
      case EFormType.multipleTags_simple:
        elements = (
          <MultipleTags_Simple
            {...fm}
            modelName={fm.modelName}
            //这里的对应redux中的属性(字段)
            field={fm.field}
            // 这里对应城市字段
            data={fm.extFieldValue1}
          />
        );
        break;
      // 订单状态多选标签
      case EFormType.orderStatus:
        // elements = <MultiSelect />;
        const orderStatusOnChange = data => {
          callback && callback(fm.field, data && data.join());
        };

        elements = (
          <OrderStatus
            placehorder={fm.placeholder}
            onChange={orderStatusOnChange}
            value={fm.value}
            containerBody={containerBody}
          />
        );
        break;
      // 订单标签多选标签
      case EFormType.orderTag:
        // elements = <MultiSelect />;
        const orderTagOnChange = data => {
          callback && callback(fm.field, data && data.join());
        };

        elements = (
          <OrderTag
            placehorder={fm.placeholder}
            onChange={orderTagOnChange}
            value={fm.value}
            containerBody={containerBody}
          />
        );
        break;
      case EFormType.submitButton:
        const resetClick = () => {
          // 重置redux中的表单数据
          reset(ModelName);
          formItem.extFieldValue4();
        };
        elements = (
          <SubmitButton
            submitTitle={formItem.extFieldValue1}
            resetTitle={formItem.extFieldValue2}
            linkTitle={formItem.extFieldValue3}
            extraTitle={formItem.extFieldValue6}
            submitClick={formItem.onClick}
            resetClick={resetClick}
            // 编辑筛选项
            linkClick={formItem.extFieldValue5}
            extraClick={formItem.extFieldValue7}
          />
        );
        break;
      default:
        break;
    }

    fmList.push(fm);

    // 新增一行数据
    const addRow = () => {
      colCount = 0;
      renderForm.push(
        renderItem(renderFormItem, renderForm.length + "_row_" + formItem.field)
      );
      renderFormItem = [];
    };

    if (targetKeys && targetKeys.length > 0) {
      // 判断为最后一个组件时直接添加到待渲染数组里
      const isLastElement = () => {
        if (FormData.lastIndexOf(formItem) == FormData.length - 1) {
          renderForm.push(
            renderItem(
              renderFormItem,
              renderForm.length + "_row_" + formItem.field
            )
          );
          renderFormItem = [];
          return true;
        }
        return false;
      };

      if (colCount < 24) {
        // 计算出剩余的空间 补位
        const colSpan = 24 - colCount;
        if (colSpan < 3) {
          let _formItem = {
            ...formItem
            // 取消注释  // 把当前行剩余的空间扩充到，当前行最后一个组件上
            //   colSpan: formItem.colSpan + colSpan
          };
          getFormItem(i, _formItem, renderFormItem, elements);
          addRow();
        } else {
          getFormItem(i, formItem, renderFormItem, elements);
        }
        elements = null;

        if (isLastElement()) break;
      } else if (colCount == 24) {
        getFormItem(i, formItem, renderFormItem, elements);
        addRow();
        elements = null;
      } else {
        // 计算出剩余的空间
        const colSpan = 24 - colCount + formItem.colSpan;
        let _formItem = { type: formItem.type, colSpan: colSpan };

        // 把剩余的不足以放置当前组件的空间，以空元素占位
        getFormItem(i, _formItem, renderFormItem, []);
        addRow();
        colCount += formItem.colSpan;
        getFormItem(i, formItem, renderFormItem, elements);
        elements = null;
      }

      if (isLastElement()) break;
    } else {
      getFormItem(i, formItem, renderFormItem, elements);
      elements = null;
      if (colCount == 24) {
        addRow();
      } else if (FormData.lastIndexOf(formItem) == FormData.length - 1) {
        addRow();
      }
    }
    i++;
  }
  return renderForm;
};
